module.exports = __webpack_public_path__ + "static/media/slide6.556afda3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/slide6.jpg
// module id = 192
// module chunks = 0